const BUY_NOW_SELECTOR = '.shopify-payment-button__button';
const BUY_NOW_COMPONENT = 'shopify-buy-it-now-button';
const COMPONENT_WAIT_TIMEOUT = 2500;

/**
 * Preserve Buy it now clicks that happen before Shopify's portable-wallet
 * component has finished registering. This can occur after a fast navigation
 * from a collection page while the button markup is already visible.
 */
document.addEventListener(
  'click',
  async (event) => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest(BUY_NOW_SELECTOR);
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;
    if (!button.closest(BUY_NOW_COMPONENT)) return;

    // Once Shopify owns the component, leave its accelerated-checkout flow alone.
    if (customElements.get(BUY_NOW_COMPONENT)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    let initialized = false;
    try {
      await Promise.race([
        customElements.whenDefined(BUY_NOW_COMPONENT),
        new Promise((_, reject) => setTimeout(reject, COMPONENT_WAIT_TIMEOUT)),
      ]);
      initialized = true;
    } catch {
      // Shopify's component did not initialize in time; use its standard
      // product-form checkout path below.
    }

    if (initialized) {
      button.click();
      return;
    }

    const form = button.closest('form');
    if (!(form instanceof HTMLFormElement)) return;

    const returnTo = document.createElement('input');
    returnTo.type = 'hidden';
    returnTo.name = 'return_to';
    returnTo.value = '/checkout';
    form.appendChild(returnTo);

    // Native submit intentionally bypasses the theme's Ajax add-to-cart
    // handler so Shopify can add the selected variant and enter checkout.
    HTMLFormElement.prototype.submit.call(form);
  },
  true
);
